import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  Table,
} from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import nextUpFundingInstructionSectionMetaOverrideSet from './metaOverrideSet';

const useStyles = makeStyles(() => ({
  root: {},
  checkbox: {
    margin: 0,
  },
  checkboxCell: {
    textAlign: 'center',
  },
  loadingIndicator: {
    padding: 0,
  },
}));

const NonAUMItemRow = ({
  resource,
}) => {
  const classes = useStyles();

  return (
    <Table.BodyRow>
      {resource.meta().template().list().map((field) => {
        const fieldName = field.attr('name');
        return (
          <td key={fieldName} className={classNames({ [classes.checkboxCell]: field.attr('type') === 'bool' })}>
            <MetaControl
              className={classNames({ [classes.checkbox]: field.attr('type') === 'bool' })}
              resource={resource}
              attrName={fieldName}
              metaOverrideSet={nextUpFundingInstructionSectionMetaOverrideSet}
            />
          </td>
        );
      })}
    </Table.BodyRow>
  );
};

NonAUMItemRow.propTypes = {
  resource: PropTypes.object.isRequired,
};

NonAUMItemRow.defaultProps = {
};

export default NonAUMItemRow;
